import {Injectable} from '@angular/core';
import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Observable, throwError} from 'rxjs';
import {NGXLogger} from 'ngx-logger';
import {catchError, finalize, map} from 'rxjs/operators';
import {ToastService} from '../../../projects/shared/src/lib/toast.service';
import {LoginDialogService} from '../shared/dialog/login-dialog/login-dialog.service';
import {NgxSpinnerService} from 'ngx-spinner';
import {UserService} from "../domain/user/service/user.service";
import {SKIP_GLOBAL_LOADING} from '../../../projects/shared/src/lib/rest-client.service';

@Injectable()
export class DefaultHttpInterceptor implements HttpInterceptor {
  private countRequest = 0;
  // 보고서를 연 시점의 버전을 후속 화면/PDF 요청에 전달한다. 다른 탭의 재분석과 섞이지 않게 한다.
  private readonly reportVersions = new Map<string, number>();

  constructor(private log: NGXLogger,
              private spinner: NgxSpinnerService,
              private toast: ToastService,
              private loginDialog: LoginDialogService,
              private userService: UserService) {
  }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const reportPath = request.url.match(/\/analysis\/(\d+)(?:\/realestates\/\d+)?\/reports\/([a-z-]+)$/);
    const titleRequest = !!reportPath && /\/analysis\/\d+\/reports\/title$/.test(request.url);
    const analysisId = reportPath?.[1];
    if (request.method === 'GET' && analysisId && !titleRequest && !request.params.has('snapshotVersion')) {
      const version = this.reportVersions.get(analysisId);
      if (version !== undefined) request = request.clone({params: request.params.set('snapshotVersion', version)});
    }
    this.log.debug('Intercept Request', request);
    const skipGlobalLoading = request.context.get(SKIP_GLOBAL_LOADING);
    if (!skipGlobalLoading) {
      this.countRequest++;
      this.spinner.show();
    }

    return next.handle(request.clone({withCredentials: true}))
      .pipe(map((response: any) => {
          const snapshotVersion = response.body?.data?.snapshotVersion;
          if (analysisId && Number.isInteger(snapshotVersion) && (titleRequest || !this.reportVersions.has(analysisId))) {
            this.reportVersions.set(analysisId, snapshotVersion);
          }
          if (response.body) {
            this.log.debug('http Response: ', response.body);
          }

          if (response.body instanceof Blob) {
            return response;
          }

          if (response.body && !response.body.success) {
            this.toast.show(response.body.message);
          }

          return response;
        }),
        catchError(response => {
          this.log.error(response.status, response.error);

          if (response.status === 401) {
            this.log.debug('Unauthorized')
            this.userService.clearSession();
          } else if (response.status === 403) {
            this.toast.show('로그인이 필요한 서비스 입니다.');
            this.loginDialog.openLoginDialog();
          }

          if (response.error.errors) {
            this.toast.show(response.error.errors[0].defaultMessage)
          } else if (response.error.message !== undefined) {
            this.toast.show(response.error.message);
          } else {
            this.toast.show(response.error);
          }
          return throwError(response);
        }), finalize(() => {
          if (!skipGlobalLoading) {
            this.countRequest--;
            if (this.countRequest === 0) {
              this.log.debug('Hide Spinner');
              this.spinner.hide();
            }
          }
        }));
  }
}
